export type MinorAmountParseResult =
  | { isValid: true; minor: number }
  | { isValid: false; error: string }

const wholeNairaFormatter = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const koboFormatter = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const majorToMinor = (input: string): MinorAmountParseResult => {
  const value = input.trim()

  if (!value) {
    return { isValid: false, error: 'Enter the confirmed cash deposit.' }
  }

  const validPlainAmount = /^(?:\d+|\d*\.\d{1,2})$/.test(value)
  const validGroupedAmount = /^\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?$/.test(value)
  if (!validPlainAmount && !validGroupedAmount) {
    return {
      isValid: false,
      error: 'Enter a non-negative amount with no more than two decimal places.',
    }
  }

  const normalized = value.replace(/,/g, '')
  const [wholePart = '0', fractionPart = ''] = normalized.split('.')
  const wholeMinor = Number(wholePart || '0') * 100
  const fractionMinor = Number(fractionPart.padEnd(2, '0') || '0')
  const minor = wholeMinor + fractionMinor

  if (!Number.isSafeInteger(minor)) {
    return { isValid: false, error: 'The amount is too large.' }
  }

  return { isValid: true, minor }
}

export const minorToMajorInput = (minor: number | null): string => {
  if (minor === null) return ''

  const whole = Math.floor(minor / 100)
  const fraction = Math.abs(minor % 100)
  return fraction ? `${whole}.${String(fraction).padStart(2, '0')}` : String(whole)
}

export const formatMinorCurrency = (minor: number | null): string =>
  minor === null
    ? 'Not provided'
    : (minor % 100 === 0 ? wholeNairaFormatter : koboFormatter).format(minor / 100)
